export enum CertificationType {
  EXAM_ENDORSEMENT = 'EXAM_ENDORSEMENT',
  FAA_WINGS = 'FAA_WINGS',
  COURSE_COMPLETION = 'COURSE_COMPLETION'
}
